"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_1 = __importDefault(require("@emotion/styled"));
var Label_1 = __importDefault(require("../Label"));
var Box_1 = __importDefault(require("../../Box"));
var react_i18next_1 = require("react-i18next");
var Paragraph_1 = __importDefault(require("../../Paragraph"));
var ErrorMessage_1 = __importDefault(require("../ErrorMessage"));
var Context_1 = require("../Context");
var utils_1 = require("../utils");
function Field(props) {
    var _this = this;
    var label = props.label, name = props.name, validate = props.validate, required = props.required, children = props.children, disableLabelBox = props.disableLabelBox, _a = props.fieldBasis, fieldBasis = _a === void 0 ? '100%' : _a, bottomContent = props.bottomContent;
    var form = (0, Context_1.useFormContext)();
    var formId = form.formId, registerField = form.registerField, unregisterField = form.unregisterField;
    var t = (0, react_i18next_1.useTranslation)().t;
    (0, react_1.useEffect)(function () {
        if (name) {
            registerField(name, {
                validate: function (value) { return __awaiter(_this, void 0, void 0, function () {
                    var requiredMessage, errorMessage;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (required && isBlank(value)) {
                                    requiredMessage = t('Required');
                                    return [2 /*return*/, requiredMessage];
                                }
                                if (!value) return [3 /*break*/, 2];
                                return [4 /*yield*/, (validate === null || validate === void 0 ? void 0 : validate(value))];
                            case 1:
                                errorMessage = _a.sent();
                                return [2 /*return*/, errorMessage];
                            case 2: return [2 /*return*/];
                        }
                    });
                }); },
            });
        }
        return function () {
            if (name) {
                unregisterField(name);
            }
        };
    }, [registerField, unregisterField, name, validate, required, t]);
    return (react_1.default.createElement(Container, { flexBasis: fieldBasis },
        !disableLabelBox &&
            react_1.default.createElement(StyledLabel, { htmlFor: (0, utils_1.getIdName)(formId, name) },
                label,
                required && '*'),
        children,
        react_1.default.createElement(Box_1.default, { minHeight: '28px' },
            react_1.default.createElement(ErrorBox, null,
                react_1.default.createElement(ErrorMessage_1.default, { name: name })),
            bottomContent)));
}
var Container = (0, styled_1.default)(Box_1.default)({
    display: 'flex',
    flexDirection: 'column',
    // fix chrome autofill overlapping with floating label
    '& input:-webkit-autofill': {
        // not sure why transform can solve the overlapping
        transform: 'scale(1)',
    },
    '& input:autofill': {
        transform: 'scale(1)',
    },
});
var ErrorBox = (0, styled_1.default)(Paragraph_1.default.P3)(function (_a) {
    var theme = _a.theme;
    return ({
        marginTop: '4px',
        marginBottom: '4px',
        color: theme.colors.error2
    });
});
var StyledLabel = (0, styled_1.default)(Label_1.default)({
    fontSize: '16px',
    lineHeight: '22px',
    marginTop: '10px',
    marginBottom: '10px',
    color: 'rgba(92, 94, 98, 1)'
});
function isBlank(value) {
    var trimmedValue = typeof value === 'string' ? value.trim() : value;
    return !trimmedValue;
}
exports.default = Field;
